import { useEffect, useRef, useState } from 'react';

export const useCode = () => {
    const [code, setCode] = useState('');
    const [maskedCode, setMaskedCode] = useState(['', '', '', '']);
    const [visibleIndex, setVisibleIndex] = useState<number|null>(null);
    const timeoutRef = useRef<any>(null);

    useEffect(() => {
        if (code.length <= 4) {
            const newMaskedCode = [...maskedCode];

            for (let i = 0; i < 4; i++) {
                if (code[i] === undefined) {
                    newMaskedCode[i] = '';
                }

                newMaskedCode[i] = code[i];
            }

            const maskedCodeLength = calculateCodeLength(maskedCode);
            const newMaskedCodeLength = calculateCodeLength(newMaskedCode);
            setMaskedCode(newMaskedCode);

            if (newMaskedCodeLength < maskedCodeLength) {
                return;
            }

            setVisibleIndex(code.length - 1);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                setVisibleIndex(null);
            }, 300);
        }
    }, [code]);

    return {
        code,
        maskedCode,
        visibleIndex,
        setCode,
    };
};

const calculateCodeLength = (code: string[]) => code.filter(char => char !== '' && char !== undefined).length;